/**
 * 缓存
 * 这个缓存的作用是，当翻页的时候，保存当前场景上下文到缓存中，起到快速恢复现场的作用
 *
 * @export
 * @class Cache
 * @author zhenliang.sun
 */
export default class Cache {
  constructor() {
    this._cacheable = true;
    this.cache = {};
  }

  /**
   *  清空缓存
   *
   * @memberof Cache
   */
  clear() {
    this.cache = {};
  }

  /**
   * 设置cache
   *
   * @param {any} key 通常为页面id
   * @param {any} obj canvas to json
   * @memberof Cache
   */
  setCache(key, obj) {
    if (!this._cacheable) {
      return;
    }
    this.cache[key] = obj || {};
  }

  /**
   * 获取某个key的内容
   *
   * @param {any} key 通常为页面id
   * @returns
   * @memberof Cache
   */
  getCache(key) {
    return this.cache[key] || {};
  }

  /**
   * 移除指定页面的cache
   *
   * @param {any} key
   * @memberof Cache
   */
  removeCache(key) {
    delete this.cache[key];
  }

  set cacheable(v) {
    this._cacheable = v;
  }
}
